import React from 'react';
import * as _ from 'lodash';
import RequireIcon from '../../components/RequireIcon';
import { SelectBox } from '../../components/select/SelectBox';
import {
  blobToJsonConversion,
  extractErrorMessage,
} from '../../utilities/commonUtil';
import { messageUtility } from '../../utilities/messageUtility';
import InOutDashboardService from '../../services/inOutDashboard/InOutDashboardService';
import InOutDashboardApi from '../../services/inOutDashboard/InOutDashboardApi';

import Styles from '../../styles/componentStyle/inOutDashboard/InOutDashboard.scss';

export class ClosedBillingMonthSelectDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false, // API等でローディング中フラグ
      closedBillingMonth: Object.create(null), // 請求月情報
      selectedClosedBillingMonth: '',
      disabledButtonClassName: 'btn--disabled',
      effectiveButtonClassName: 'btn-fixedsize',
      informationModal: {
        show: false,
        message: '',
      },
    };

    // 現場IDが存在するか確認する
    if (_.isUndefined(props.dialog.state.field_id)) {
      throw new Error(
        'ClosedBillingMonthSelectDialog.jsx constructor props.field_id'
      );
    }
  }

  downloadMonthlyCountExcel = () => {
    const state = _.cloneDeep(this.state);
    if (state.isLoading) {
      return;
    }

    this.setState({ isLoading: true }, () => {
      InOutDashboardApi.fetchMonthlyCountExcel(
        this.props.dialog.state.field_id,
        state.selectedClosedBillingMonth.replace('年', '/').replace('月', '')
      )
        .then(result => {
          if (result instanceof Blob) {
            InOutDashboardService.downloadExcel(result);
          } else {
            blobToJsonConversion(result.data)
              .then(blob => {
                this.props.dialog.childSetDialog(
                  true,
                  extractErrorMessage(blob.message)
                );
                this.props.dialog.callback.back();
              })
              .catch(() => {
                if (result.status === 403) {
                  this.props.dialog.childSetDialog(
                    true,
                    messageUtility.getMessage('E-000-063')
                  );
                  this.props.dialog.callback.back();
                } else {
                  this.props.dialog.childSetDialog(
                    true,
                    messageUtility.getMessage('E-000-021')
                  );
                  this.props.dialog.callback.back();
                }
              })
              .finally(() => {
                this.setState(state);
              });
          }
        })
        .catch(error => {
          this.props.dialog.childSetDialog(true, extractErrorMessage(error));
          this.props.dialog.callback.back();
        })
        .finally(() => {
          state.isLoading = false;
          this.setState(state);
          this.props.dialog.callback.back();
        });
    });
  };
  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  async componentDidMount() {
    const state = _.cloneDeep(this.state);
    if (state.isLoading) {
      return;
    }

    // 請求月一覧を取得を取得
    this.setState({ isLoading: true }, () => {
      InOutDashboardApi.fetchClosedBillingMonth(
        this.props.dialog.state.field_id
      )
        .then(response => {
          if (response.result === true) {
            if (
              response.data.entities &&
              response.data.entities.kaoreco_closed_field_billings &&
              response.data.entities.kaoreco_closed_field_billings.length > 0
            ) {
              state.closedBillingMonth =
                response.data.entities.kaoreco_closed_field_billings;
              state.selectedClosedBillingMonth =
                response.data.entities.kaoreco_closed_field_billings[0].billing_month;
            } else {
              this.props.dialog.childSetDialog(
                true,
                messageUtility.getMessage('E-000-001-05')
              );
              this.props.dialog.callback.back();
            }
          } else {
            this.props.dialog.childSetDialog(
              true,
              extractErrorMessage(response)
            );
            this.props.dialog.callback.back();
          }
        })
        .catch(error => {
          this.props.dialog.childSetDialog(true, extractErrorMessage(error));
          this.props.dialog.callback.back();
        })
        .finally(() => {
          state.isLoading = false;
          this.setState(state);
        });
    });
  }
  render() {
    return (
      <React.Fragment>
        <div id='dialog' className={`${Styles.ClosedBillingMonthDialog}`}>
          <div className={'dialog-md dialog--modal'}>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>{data.title}</span>
            </div>
            <div className='dialog-md__body'>
              <div className='dialog-form'>
                <div className='dialog-form__item'>
                  <div className='form-list form-list-default'>
                    <div className='form-list__item'>
                      <div className='form-list__label'>
                        <span className='label'>
                          {data.target.month}
                          <RequireIcon />
                        </span>
                      </div>
                      <div className='form-list__element'>
                        <SelectBox
                          name={'close_billing_months'}
                          value={this.state.selectedClosedBillingMonth}
                          items={this.state.closedBillingMonth}
                          isPlaceholderHidden={true}
                          keyName='billing_month'
                          valueName='billing_month'
                          itemName='billing_month'
                          onChange={e =>
                            this.setState({
                              selectedClosedBillingMonth: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='dialog-md__footer-horizontal'>
              <button
                className='btn-fixedsize--sub'
                onClick={() => this.props.dialog.callback.back()}
              >
                {data.buttonTitle.back}
              </button>
              <button
                className={
                  !this.state.selectedClosedBillingMonth
                    ? this.state.disabledButtonClassName
                    : this.state.effectiveButtonClassName
                }
                onClick={() => this.downloadMonthlyCountExcel()}
                disabled={!this.state.selectedClosedBillingMonth}
              >
                {data.buttonTitle.export}
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ClosedBillingMonthSelectDialog;

// 定数
const data = {
  title: '出力するデータを選択',
  target: {
    month: '対象月',
  },
  buttonTitle: {
    export: '出力する',
    back: '戻る',
    close: '閉じる',
  },
};



// WEBPACK FOOTER //
// ./src/components/modals/ClosedBiilingMonthSelectDialog.jsx